import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type DevState = {
  /**
   * Whether to show the debug boundary layer on the map.
   * This visualizes the fetch boundaries with corner markers and a dashed rectangle.
   */
  showBoundaryLayer: boolean;
};

const initialState: DevState = {
  showBoundaryLayer: false
};

const devSlice = createSlice({
  name: "dev",
  initialState,
  reducers: {
    /**
     * Toggle the debug boundary layer visibility.
     */
    toggleBoundaryLayer: (state) => {
      state.showBoundaryLayer = !state.showBoundaryLayer;
    },
    /**
     * Set the debug boundary layer visibility explicitly.
     */
    setShowBoundaryLayer: (state, action: PayloadAction<boolean>) => {
      state.showBoundaryLayer = action.payload;
    }
  }
});

export const { toggleBoundaryLayer, setShowBoundaryLayer } = devSlice.actions;
export default devSlice.reducer;

// Selectors
export const selectShowBoundaryLayer = (state: { dev: DevState }) =>
  state.dev.showBoundaryLayer;
